export default defineNuxtPlugin({
    enforce: 'post',
    async setup() {
        const { $bus } = useNuxtApp()

        $bus.$on('fbPageEvent', async (payload) => {
            await useFetch(
                'https://graph.facebook.com/v17.0/579110566846822/events?access_token=EAAG1SVyRHH4BO5yuZBbnhjUiE0pnl3bOroI56lPjQGOCtzf1ZAxT8fAqeZAH4tAgL3ZAONgUDzpS3jv1VwO2AEPgzHkUKz0kZADBBXMTERWRN7fyquLrMPEPGGz0k8QRGofS82XEVKX8L3nLxOWfoJeJZBUGmXKoZBy8bwPVqUQCsAZAt2UnHuzZCk0ZA9R691xXn3KAZDZD',
                {
                    method: 'post',
                    body: payload,
                },
            )
        })
    },
})
